import { Component, Output, EventEmitter, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { BaseEditComponent } from '@app/cp/shared/base-components/base-edit.component';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { SaveMode } from '@app/cp/shared/enums/SaveMode';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { v_InvoiceLineItemBus } from '../../shared/models/v_InvoiceLineItemBus';
import { InvoiceService } from '../../shared/services/invoice.service';
import { InvCopytoNewLineItemsComponent } from './lineitems/invcopytonew-lineitems.component';
import { CommonFunctions } from '../../shared/static/common-functions';
import { InvoiceLinesSaveParam } from '../../shared/models/InvoiceLinesSaveParam';
import { InvoiceLinesBus } from '../../shared/models/InvoiceLinesBus';
import { InvoiceMessageInfo } from '../../shared/models/InvoiceMessageInfo';
import { GItem } from '../../shared/models/GItem';
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';

@UseCPLoader()
@Component({
    selector: 'invoice-copyto-new',
    templateUrl: './invoice-copyto-new.component.html',
    styleUrls: ['./invoice-copyto-new.component.scss'],
    standalone: false
})
export class InvoiceCopytoNewComponent extends BaseEditComponent<v_InvoiceLineItemBus, InvoiceService, null, null> {
    compLoader: ICPLoader = this as any;
    constructor(globals: GlobalsService,  qry_rd: DQOIReferenceDataQuery, svc_data: InvoiceService) {
        super(globals, qry_rd);
        this.svc_data = svc_data;
        this.readOnly = false;
        this.saveMode = SaveMode.all;
        this.appCode = "Split Invoice "
    }
    @ViewChild('CopyToNewLineItems') protected lineItems: InvCopytoNewLineItemsComponent;
    @Output() closed: EventEmitter<any> = new EventEmitter<any>();
    //@Output() titleChild = new EventEmitter<string>();
    editing: boolean = false;
    gridData: v_InvoiceLineItemBus[];
    id: any;
    _customerId: any;
    _locationId: any;
    get customerId(): any {
        return this._customerId;
    }
    get locationId(): any {
        return this._locationId;
    }
    set customerId(value: any) {
        this._customerId = value;
    }
    set locationId(value: any) {
        this._locationId = value;
    }
    close(data: any = null) {
        //        super.close(data);
        this.gridData = null;
        this.editing = false;
        this.closed.emit(data);
    }

    cancel() {
        this.gridData = null;
//        this.clear();
        this.editing = false;
        this.closed.emit(false);
    }
    getData() {
        this.dataLoading = true;
        this.subs_data = this.svc_data.getLineItemsViewForSplit(this.id, this.code).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                let arr = [];
                for (let i = 0; i < info.primaryReturn.length; i++) {
                    let busObj: v_InvoiceLineItemBus = new v_InvoiceLineItemBus(info.primaryReturn[i]);
                    //TODO [jd 2025.01.02] Remove after Sprint 11 deployment. Need to verify usecases in production
                    // if (!busObj.isPrintable || (busObj.isPrintable && !busObj.isLabor)) {
                    //     arr.push(busObj);
                    // }
                    arr.push(busObj); // always push (ITDEV-1469)
                }
                this.gridData = arr; // info.primaryReturn as OrderBillBus[];
                this.dataLoading = false;
                this.editing = true;

            }
        });

    }

    goTo() {
        this.closed.emit(this.newInvoiceId);
    }
    newInvoiceNumber: string;
    newInvoiceId: any;
    get hasNewInvoiceId(): boolean {
        return CommonFunctions.hasGuidValue(this.newInvoiceId);
    }
    getSelected(): InvoiceLinesBus[] {
        let selArr: v_InvoiceLineItemBus[] = [];
        let arr: InvoiceLinesBus[] = [];
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            selArr = this.gridData.filter(s => s.selected == true);
        }
        if (CommonFunctions.hasArrayElementValue(selArr)) {
            for (let i = 0; i < selArr.length; i++) {
                let busObj: InvoiceLinesBus = new InvoiceLinesBus(selArr[i]);
                arr.push(busObj);
            }
        }
        return arr;
    }
    saveAll() {
        this.editing = false;
        let param: InvoiceLinesSaveParam = new InvoiceLinesSaveParam();
        param.invoiceId = this.id;
        param.lineItems = this.getSelected();
        if (this.isWarranty) {
            param.customerId = this.customerId;
            param.locationId = this.locationId;
            param.code = "W";
        }
        else {
            param.code = "C";
        }
        console.log("invcopytonew-save: ", param);
        this.compLoader.cpLoaderOn(true);
        this.svc_data.copyLinesToNewInvoice(param).subscribe((info: InvoiceMessageInfo) => {
            if (!info.saveError) {
                this.newInvoiceId = info.primaryId;
                this.newInvoiceNumber = info.primaryNumber;
                this.saveSuccess();
                this.getData();
            }
            else {
                this.saveError(info.message);
            }
            this.compLoader.cpLoaderOff();
        });
//        this.closed.emit(true);
    }
    get hasGridData(): boolean {
        return CommonFunctions.hasValue(this.gridData);
    }
    get gridDataCount(): number {
        return CommonFunctions.hasArrayElementValue(this.gridData) ? this.gridData.length : 0;
    }
    get customerLocationSelectionValid() : boolean {
        let valid = true;
        if (this.isWarranty) {
            if (this.hasCustomer && !this.hasLocation) {
                valid = false;
            }
        }
        return valid;
    }
    get canSave(): boolean {
        let okToSave: boolean = this.gridDataCount > 0; // && (this.code !== "W" || (this.code === "W"));
        return okToSave;
    }
    isWarranty: boolean = false;
    code: string = null;
    setup({id,code }) {
        this.newInvoiceId = null;
        this.newInvoiceNumber = null;
        this.customerId = null;
        this.locationId = null;
        this.gridData = [];
        this.id = id;
        this.code = code;
        this.isWarranty = this.code === "W" ? true : false;
        this.getData();
    }
    onChanged(e: BaseMessageInfo) {
        console.log("onChanged: ", e);
    }

    customerCBOChanged(item: any) {
        if (CommonFunctions.hasValue(item)) {
            this.customerChanged(item.value);
        }
        else {
            this.customerChanged(null);
        }
    }
    locationCBOChanged(item: GItem) {
        if (CommonFunctions.hasValue(item)) {
            this.locationChanged(item.value);
        }
        else {
            this.locationChanged(null);
        }
    }
    customerChanged(id: any, holdLocationChange: boolean = false) {
        this.location = null;
        let custId: any = id;
        if (CommonFunctions.hasValue(this.referenceData) && CommonFunctions.hasArrayValue(this.referenceData.locations) && CommonFunctions.hasValue(id)) {
            this.customer = this.referenceData.getCustomerDesc(id); // .customers.find(s => s.value === id).description;
            this.customerLocations = this.referenceData.locations.filter(e => e.category === id);
        }
        else {
            this.customer = null;
            //  this.editForm.value.customerId = null;
            this.customerLocations = [];
            this.customerGeoLocations = [];
        }
//        this.locationChanged(null);
    }

}
